/**
 * Puce d'une SKILLCARD choisie : petite tuile avec la créature origami sur le fond de
 * la carte et sa bordure (teinte du niveau), puis le titre. Données = dernier instantané
 * publié (`usePublicCard`, même cache que la page de la carte) ; titre de repli tant
 * qu'il charge.
 */

import { MathText } from '@jeraisonne/ui';
import { OrigamiCreature } from '@jeraisonne/ui/tool-cards';
import { cardPalette } from '@jeraisonne/db/cards';
import { usePublicCard } from '@/lib/cards/api';

export function SkillcardChip({
  cardId,
  fallbackTitle,
}: {
  cardId: string;
  fallbackTitle?: string;
}) {
  const card = usePublicCard(cardId).data?.card;
  const title = card?.title ?? fallbackTitle ?? 'SKILLCARD';
  const palette = card ? cardPalette(card.levels ?? [], card.color_theme) : null;
  return (
    <span className="bg-primary-50 text-primary-700 inline-flex max-w-full items-center gap-1.5 rounded-full py-1 pl-1 pr-3 text-xs font-semibold">
      <span
        aria-hidden
        data-testid="skillcard-chip-tile"
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md border-2"
        style={
          palette
            ? { background: palette.bg, borderColor: palette.accent }
            : { borderColor: 'currentColor', opacity: 0.4 }
        }
      >
        {card && palette && (
          <OrigamiCreature creature={card.creature} accent={palette.accent} className="h-4 w-4" />
        )}
      </span>
      <span className="min-w-0 truncate">
        <MathText>{title}</MathText>
      </span>
    </span>
  );
}
